import React, { useState } from 'react';
import { Stack, IconButton, InputAdornment, TextField } from '@mui/material';
import Iconify from '../../components/iconify/Iconify';

/**
 * login input component
 * @typedef {Object} props
 * @param {string} emailText - email input label text
 * @param {string} pwText - password input label text
 * @param {Object} values - values state
 * @param {function} onChange - value change function
 * @returns
 */
function LoginInputForm({ emailText, pwText, values, onChange }) {
  const [shownPassword, setShowPassword] = useState(false);
  return (
    <form>
      <Stack spacing={1}>
        <TextField name="email" label={emailText} value={values.inputId} onChange={onChange} />

        <TextField
          name="password"
          label={pwText}
          value={values.inputPw}
          onChange={onChange}
          type={shownPassword ? 'text' : 'password'}
          autoComplete="on"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!shownPassword)} edge="end">
                  <Iconify icon={shownPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Stack>
    </form>
  );
}

export default LoginInputForm;
